// The Spraytan Queen — homepage-specific behavior (index template only)

// ─── Hero title animation safety net ───
// The "The"/"Spraytan"/"Queen" entrance (assets/homepage.css) runs on a CSS
// animation-delay timeline. If the browser pauses that timeline mid-flight
// (e.g. phone screen locks or the tab gets backgrounded during the ~2.5s
// sequence), the title can get stuck blurred or off-screen indefinitely.
// Force the finished state after a timeout well past the animation as a
// fallback, regardless of whether the CSS animation actually completed.
const heroTitleEl = document.querySelector('.hero-title');
if (heroTitleEl) {
    // Sequence ends ~5.2s in (sheen: 3.9s delay + 1.3s duration); settle a
    // second later so the fallback never cuts a healthy animation short.
    setTimeout(() => heroTitleEl.classList.add('hero-title-settled'), 6200);
}

// ─── Particles ───
const particlesContainer = document.getElementById('particles');
if (particlesContainer) {
    for (let i = 0; i < 30; i++) {
        const p = document.createElement('div');
        p.className = 'particle';
        p.style.left = Math.random() * 100 + '%';
        p.style.top = Math.random() * 100 + '%';
        p.style.animationDelay = Math.random() * 6 + 's';
        p.style.animationDuration = (4 + Math.random() * 4) + 's';
        particlesContainer.appendChild(p);
    }
}

// ─── About Wipe Reveal ───
const aboutSection = document.querySelector('.about');
if (aboutSection) {
    const aboutObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                aboutSection.classList.add('animate');
                aboutObserver.unobserve(aboutSection);
            }
        });
    }, { threshold: 0.2 });
    aboutObserver.observe(aboutSection);
}

// ─── Process Step Loop ───
(function() {
    const steps = document.querySelectorAll('.process-step');
    if (!steps.length) return;
    let current = 0;
    let interval = null;

    function activateStep() {
        steps.forEach(s => s.classList.remove('active'));
        steps[current].classList.add('active');
        current = (current + 1) % steps.length;
    }

    function startLoop() {
        activateStep();
        interval = setInterval(activateStep, 2000);
    }

    const processSection = document.getElementById('process');
    if (!processSection) return;
    const processObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !interval) {
                startLoop();
            }
        });
    }, { threshold: 0.3 });
    processObserver.observe(processSection);
})();

// ─── FAQ Accordion ───
document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
        const item = btn.parentElement;
        const isOpen = item.classList.contains('active');
        // Luk alle andre
        document.querySelectorAll('.faq-item.active').forEach(i => {
            i.classList.remove('active');
            i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        });
        // Toggle denne
        if (!isOpen) {
            item.classList.add('active');
            btn.setAttribute('aria-expanded', 'true');
        }
    });
});
